import React from 'react';
import { Wrapper } from './styles';
import Grid from '../components/Grid';
import { FormattedMessage } from 'react-intl';
import { TitleHeader } from 'components/commons/Template/style';

const MonitoringHistoryPage = () => {
  return (
    <Wrapper id="wrapperMH">
      <TitleHeader id="filterMH">
        <FormattedMessage id="trainingFacility.title" />
      </TitleHeader>
      <Grid />
    </Wrapper>
  );
};

export default MonitoringHistoryPage;
